import { render, staticRenderFns } from "./Hubla.vue?vue&type=template&id=19dcce8a&"
import script from "./Hubla.vue?vue&type=script&lang=js&"
export * from "./Hubla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports